import { styled as n } from "@mui/material";
import m from "../assets/icon-goto-marketplace.svg.js";
import p from "./ApeironGotoRoundButton.js";
import { useTranslation as s } from "react-i18next";
import { jsx as i } from "react/jsx-runtime";
const a = n(p)`
  .Custom-Container {
    .Custom-Link {
      .Custom-Icon-Text {
        gap: 8px;
        .Custom-Icon {
          margin-left: 4px;

          ${(t) => t.theme.breakpoints.up("res768")} {
            width: 62px;
          }
          ${(t) => t.theme.breakpoints.down("res768")} {
            width: 52px;
          }
        }
      }
    }
  }
`, d = (t) => {
  const {
    url: o,
    target: r
  } = t, {
    t: e
  } = s();
  return /* @__PURE__ */ i(a, {
    icon: m.toString(),
    url: o,
    target: r,
    text: e("goto.marketplace")
  });
};
export {
  d as default
};
//# sourceMappingURL=GotoMarketplace.js.map
